module.exports = __webpack_public_path__ + "img/try_4.bf7dc794.png";